import React, {useState, useEffect} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';

export default function CourseMenuHeader({courseName, coursesWithContent, coursesWithoutContent, privateClassesOnly}) {
    const initialActiveItem = privateClassesOnly ? 'next' : 'video'
    const [active, setActive] = useState(initialActiveItem)
    const [isSelectingDomain, setIsSelectingDomain] = useState(false)

    useEffect(() => {
        const eventName = privateClassesOnly ? 'privateclass_menu_tabs' : 'course_menu_tabs'
        const event = new CustomEvent(eventName, {detail: active})
        document.dispatchEvent(event)
    }, [active])

    return (
        <Container>
                {!privateClassesOnly && (
                <MenuContainer>
                    <Item
                        isActive={active === 'video'}
                        onClick={() => setActive('video')}>Videos
                    </Item>
                </MenuContainer>
                )}

                {privateClassesOnly && (
                <MenuContainer>
                    <Item
                        isActive={active === 'next'}
                        onClick={() => setActive('next')}>Proximas
                    </Item>
                    <Item
                        isActive={active === 'old'}
                        onClick={() => setActive('old')}>Antiguas
                    </Item>
                    </MenuContainer>
                )}

            <SelectContainer>
                <CourseName onClick={() => setIsSelectingDomain(coursesWithContent.length === 0 ? false : !isSelectingDomain)}>{courseName}</CourseName>
                <ImageCourse isDeployed={isSelectingDomain} src='/images/arrow_black.svg'/>
                {isSelectingDomain && (
                    <SelectContainerOver>
                        <CloseContainer onClick={() => setIsSelectingDomain(false)}><CloseIcon>x</CloseIcon></CloseContainer>

                        <SectionTitle>Asignaturas con contenido grabado</SectionTitle>
                        {coursesWithContent.map(course => (<LinkContainerOVer  href={course.url}>{course.name}</LinkContainerOVer> ))}

                        <SectionTitle>Asignaturas sólo con clases</SectionTitle>
                        {coursesWithoutContent.map(course => (<LinkContainerOVer  href={course.url}>{course.name}</LinkContainerOVer> ))}

                        <LinkContainerOVer href={'/privateclass-tool'}>
                            <SectionTitle>Clases en directo</SectionTitle>
                        </LinkContainerOVer>
                    </SelectContainerOver>
                )}

            </SelectContainer>
        </Container>
    )
}

const ImageCourse = styled.img`
 margin-left: 8px;
 transform: rotate(${props => props.isDeployed ? '90' : '0'}deg);
 width: 12px;
`
const CourseName = styled.div`
    cursor:pointer;
    &:hover {
        color: white;
    }
`

const CloseContainer = styled.div`
    display: flex;
    justify-content:flex-end;
    cursor: pointer;
`

const CloseIcon = styled.div`
    color: black;
    font-size: 14px;
    margin-right: 16px;
    margin-top: 4px;

      &:hover {
        color: #FA9F63;
    }
`
const SelectContainerOver = styled.div`
    position: absolute;
    background-color: white;
    left: 0;
    width: 400px;
    margin-top: 42px;
    display: flex;
    flex-direction: column;
    padding-bottom: 12px;
    z-index: 1;
`

const LinkContainerOVer = styled.a`
    margin-top: 12px;
    color: black;
    text-align: center;
`

const SelectContainer = styled.div`
    padding-right: 8px;
    color: black;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
`
const MenuContainer = styled.div`
    display: flex;
    flex-direction: row;
`

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content:space-between;
    padding-top: 43px;

`

const Item = styled.div`
    padding-left: 8px;
    padding-right: 8px;
    font-size: 14px;
    cursor: pointer;
    font-weight: ${props => props.isActive ? 'bold' : 'lighter'};
    color: ${props => props.isActive ? 'white' : '#5F676D'};
`

const SectionTitle = styled.h3`
    margin: 12px 0 0;
    text-align: center;
    background-color: antiquewhite;
`

if (document.getElementsByTagName('course-tool-menu-header')) {
    const elms = document.getElementsByTagName('course-tool-menu-header')

    for (let elm of elms) {
        const courseName = elm.attributes['course-name'].value
        const otherCoursesWithContent = JSON.parse(elm.attributes['other-courses-with-content'].value)
        const otherCoursesWithoutContent = JSON.parse(elm.attributes['other-courses-without-content'].value)
        const privateClassesOnly = JSON.parse(elm.attributes['private-classes-only'].value)

        ReactDOM.render(
            <CourseMenuHeader
                courseName={courseName}
                coursesWithContent={otherCoursesWithContent}
                coursesWithoutContent={otherCoursesWithoutContent}
                privateClassesOnly={privateClassesOnly}
            />,
            elm
        );
    }
}
